import { createTermsTagsManager } from '../../utils/createTermsTagsManager';

export const wordsIncludeTagsManager = createTermsTagsManager({
  jsonQueryKey: 'description_include',
  template: 'Содержит &quot;%s&quot;',
  id: 'wordsInclude',
});
